import {AppUrls} from 'shared/config/model/urls';
import {Pages} from 'shared/config/model/pages';

import React from 'react';
import {i18n} from '@lingui/core';
import {t} from '@lingui/core/macro';

import {IncidentsScreen} from 'entities/monitor';
import {useCreateGate} from 'entities/tariff';
import {ExceededModal} from 'entities/user';
import CreateServerButton from 'features/server/ui/Server/CreateServerButton/CreateServerButton';
import ServerModal from 'features/server/ui/Server/ServerModal';
import useServerIncidents from 'features/server/model/useServerIncidents';
import {getServerIncidentColumns} from 'features/server/lib/serverIncidentHelper';

import ServerIncidentRow from '../ServerIncidentRow/ServerIncidentRow';
import ServerIncidentsFiltersModal from '../ServerIncidentsFilters/ServerIncidentsFiltersModal';

const ServerIncidentsScreen: React.FC = () => {
    const {
        pagination, isLoading, isFetching, refetch, search, onSearch, sort, setSort, servers,
        metricOptions, openCount, closedCount, plugState, canCreateServer,
    } = useServerIncidents();
    const {
        open: handleCreate, close: closeCreateGate, isCreateOpen, isExceededOpen,
    } = useCreateGate(canCreateServer);

    return (
        <IncidentsScreen
            documentTitle={t`Инциденты серверов | Overseer`}
            title={i18n._(Pages.SERVER_INCIDENTS)}
            backUrl={AppUrls.SERVERS}
            isFetching={isFetching}
            refetch={refetch}
            summary={{unresolved: openCount, resolved: closedCount}}
            onSubmitSearch={onSearch}
            searchValue={search}
            renderFilterModal={(state) =>
                <ServerIncidentsFiltersModal servers={servers} metricOptions={metricOptions} {...state}/>
            }
            plugState={plugState}
            createButton={<CreateServerButton/>}
            createText={t`Добавить сервер`}
            onCreate={handleCreate}
            columns={getServerIncidentColumns(false)}
            items={pagination?.items}
            rowFactory={(item) =>
                <ServerIncidentRow
                    key={item.uuid}
                    item={item}
                />
            }
            isLoading={isLoading}
            pagination={pagination}
            sort={sort}
            setSort={setSort}
        >
            <ServerModal
                open={isCreateOpen}
                handleClose={closeCreateGate}
            />

            <ExceededModal
                isOpen={isExceededOpen}
                handleClose={closeCreateGate}
                type="servers"
            />
        </IncidentsScreen>
    );
};

export default ServerIncidentsScreen;
